import { render } from "./grupolistadodocumentacion.vue?vue&type=template&id=8f6f6892&scoped=true"
import script from "./grupolistadodocumentacion.vue?vue&type=script&lang=js"
export * from "./grupolistadodocumentacion.vue?vue&type=script&lang=js"

import "./grupolistadodocumentacion.vue?vue&type=style&index=0&id=8f6f6892&scoped=true&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f6f6892"]])

export default __exports__